// react components
import React from 'react'
import {
    IonCheckbox,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
} from '@ionic/react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import TextareaAutosize from 'react-textarea-autosize'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type UrlInputV2825Props = {
    directionRtl?: boolean
    disabled?: boolean
    name: string
    onChange: any
    canSkipDataRetrieve?: boolean
    getMetaIsLoading?: boolean
    placeholder?: string
    value: string
}

// main
export const UrlInputV2825: React.FC<UrlInputV2825Props> = React.memo(({
    directionRtl,
    disabled,
    name,
    onChange,
    getMetaIsLoading,
    placeholder,
    value,
    canSkipDataRetrieve,
}) => {

    const dispatch = useDispatch()
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    function onInputChange(value: string | null | undefined) {
        try {
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'UrlInputV2825',
                'onInputChange',
            ))
        }
    }

    function onSkipDataRetrieve(e: any) {
        try {
            onChange({
                name: 'skip_data_retrieve',
                value: e,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextAreaInput',
                'onSkipDataRetrieve',
            ))
        }
    }

    return (
        <>
            <TextareaAutosize
                className={`text-area-input-825${directionRtl ? ' rtl' : ''}`}
                disabled={disabled}
                name={name}
                onChange={(e) => onInputChange(e.target.value)}
                placeholder={placeholder}
                rows={1}
                value={value}
            />
            {canSkipDataRetrieve && (
                <IonList>
                    <IonItem lines='none' color={'light'}>
                        <IonLabel className='tiw-label-825'>{reduxText[10241]}</IonLabel>
                        <IonCheckbox
                            className='tiw-checkbox'
                            slot='start'
                            onIonChange={(e) => onSkipDataRetrieve(e.detail.checked)}
                        />
                    </IonItem>
                </IonList>
            )}
            {getMetaIsLoading && (
                <div className='tiw-loader-825'>
                    <p className='tiw-loader-text'>{reduxText[10242]}</p>
                    <IonSpinner
                        className='tiw-loader-spinner'
                    />
                </div>
            )}
        </>
    )
})
